module.exports = __webpack_public_path__ + "img/s-ign-warning.52343607.svg";